export const AGE_MIN: number = 3;
export const AGE_MAX: number = 15;
// permet de fixer le délai des requêtes (latence)
export const REQUEST_DELAY: number = 500
